const buttonClasses = 'bg-danger-700 text-white';

const buttonHoverClasses = 'hover:bg-danger-900';

const buttonIconClasses = 'fill-white';

const buttonDangerClasses = { buttonBlogVariantClasses: [buttonClasses, buttonHoverClasses], buttonIconClasses };

export default buttonDangerClasses;
